export { detectSeries, reduce } from 'async-es';